export const required = (value) => {
  if (!value) {
    return 'This field is required.';
  }
};

export const errorMessage = (error) => (error ? error.message : null);
